/* Product page: format choice, quantity, add to bag, free-shipping hint, dock, gallery and zoom. */
(() => {
  const root = document.querySelector('[data-product-root]');
  if (!root) return;
  const $ = (s, r = root) => r.querySelector(s);
  const $$ = (s, r = root) => [...r.querySelectorAll(s)];
  const money = (c) => (window.Scentzi && window.Scentzi.money ? window.Scentzi.money(c) : (c / 100).toFixed(2));
  const form = $('[data-product-form]');
  const idInput = $('[data-variant-id]');
  const qtyInput = $('[data-qty-input]');
  const goal = +root.dataset.goal || 10000;
  let cartTotal = +root.dataset.cartTotal || 0;
  const checkIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 256 256" aria-hidden="true"><path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"></path></svg>';

  const selectedRadio = () => $('.ab-formats input:checked');
  const price = () => { const r = selectedRadio(); return r ? +r.dataset.price : +(root.dataset.basePrice || 0); };
  function syncTotals() {
    const q = +qtyInput.value, total = price() * q;
    $$('[data-buy-total]').forEach((el) => { el.textContent = money(total || price()); });
    const left = goal - cartTotal - total;
    const slot = $('[data-shipping-left]');
    if (slot) slot.innerHTML = left > 0 ? `Met deze keuze nog <b>${money(left)}</b> tot gratis verzending.` : 'Met deze keuze verzenden we gratis.';
    $('[data-qty="-1"]').disabled = q <= 1;
    $('[data-qty="1"]').disabled = q >= 10;
  }
  // Expected delivery dates from the delivery-time setting ("6–10 werkdagen"): weekends and Dutch
  // public holidays on which parcels are not delivered don't count (same rules as the React app).
  (function deliveryWindow() {
    const list = $('[data-delivery-days]'), slot = $('[data-delivery-window]');
    const m = list && (list.dataset.deliveryDays || '').match(/(\d+)\D+(\d+)/);
    if (!m || !slot) return;
    const key = (d) => `${d.getMonth() + 1}-${d.getDate()}`;
    const holidays = (y) => {
      const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
        g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7, n = Math.floor((a + 11 * h + 22 * l) / 451),
        month = Math.floor((h + l - 7 * n + 114) / 31), day = ((h + l - 7 * n + 114) % 31) + 1;
      const easter = (x) => key(new Date(y, month - 1, day + x));
      return new Set(['1-1', new Date(y, 3, 27).getDay() === 0 ? '4-26' : '4-27', '12-25', '12-26', easter(1), easter(39), easter(50)]);
    };
    const add = (days) => {
      const now = new Date(), d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      for (let n = 0; n < days;) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w && w !== 6 && !holidays(d.getFullYear()).has(key(d))) n++; }
      return d;
    };
    const fmt = (d) => new Intl.DateTimeFormat('nl-NL', { weekday: 'short', day: 'numeric', month: 'short' }).format(d).replace(/\./g, '');
    const a = add(+m[1]), b = add(+m[2]), first = a.getMonth() === b.getMonth() ? fmt(a).replace(/ \S+$/, '') : fmt(a);
    slot.innerHTML = `Verwacht tussen <b>${first} en ${fmt(b)}</b>.`;
  })();

  // One "Welk formaat past bij jou?" section per size (tools/extract-pdp.py): show the chosen one,
  // and keep the #abyss-formaten anchor on it.
  function syncFormatSections(size) {
    const all = $$('[data-formats-size]');
    if (!all.length) return;
    const pick = all.find((sec) => sec.dataset.formatsSize === size) || all[0];
    all.forEach((sec) => { sec.hidden = sec !== pick; if (sec !== pick) sec.removeAttribute('id'); });
    pick.id = 'abyss-formaten';
  }
  function select(radio, scroll) {
    if (!radio || radio.disabled) return;
    radio.checked = true;
    $$('.ab-formats label').forEach((label) => {
      const on = label.contains(radio);
      label.classList.toggle('selected', on);
      const span = label.querySelector('span');
      const icon = span.querySelector('svg');
      if (on && !icon) span.insertAdjacentHTML('beforeend', checkIcon);
      if (!on && icon) icon.remove();
    });
    idInput.value = radio.dataset.variant;
    $('[data-price]').textContent = money(+radio.dataset.price);
    const label = document.querySelector('[data-dock-label]');
    if (label) label.textContent = radio.dataset.title;
    if (radio.dataset.image) {
      const img = $('.sz-variant-image') || $('.sz-gallery-stage');
      if (img) { img.srcset = ''; img.src = radio.dataset.image; }
      const sel = $('.sz-selected-image');
      if (sel) { sel.srcset = ''; sel.src = radio.dataset.image; }
    }
    $$('[data-sample-link]').forEach((b) => { b.hidden = radio.value === '3'; });
    $$('.ab-format-cards article').forEach((card) => {
      const btn = card.querySelector('[data-select-size]');
      const on = btn && btn.dataset.selectSize === radio.value;
      card.classList.toggle('selected', !!on);
      if (btn) btn.setAttribute('aria-pressed', on);
    });
    syncFormatSections(radio.value);
    const url = new URL(location.href); url.searchParams.set('variant', radio.dataset.variant);
    history.replaceState(null, '', url);
    syncTotals();
    if (scroll) document.getElementById('abyss-kiezen').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }
  $$('.ab-formats input').forEach((r) => r.addEventListener('change', () => select(r)));
  if (selectedRadio()) syncFormatSections(selectedRadio().value);
  root.addEventListener('click', (e) => {
    // "Hoe werkt dit?" opens the "Levering en retour" accordion and brings it into view.
    const how = e.target.closest('[data-open-delivery]');
    const acc = how && document.getElementById('pdp-levering');
    if (acc) {
      e.preventDefault();
      acc.open = true;
      acc.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      return;
    }
    const pick = e.target.closest('[data-select-size]');
    if (pick) {
      e.preventDefault();
      // Owner request 3 October: choosing in "Welk formaat past bij jou?" keeps the page where it is.
      select($(`.ab-formats input[value="${pick.dataset.selectSize}"]`), !pick.closest('.pdp3-panel, .pdp3-formats'));
    }
    const step = e.target.closest('[data-qty]');
    if (step) {
      qtyInput.value = Math.min(10, Math.max(1, +qtyInput.value + +step.dataset.qty));
      $('[data-qty-output]').textContent = qtyInput.value;
      syncTotals();
    }
  });
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    window.Scentzi.addItems([{ id: +idInput.value, quantity: +qtyInput.value }], $('[data-buy]'));
  });
  document.addEventListener('scentzi:cart', () => {
    fetch((window.Scentzi.routes.cart || '/cart') + '.js').then((r) => r.json()).then((c) => { cartTotal = c.total_price; syncTotals(); }).catch(() => {});
  });

  /* dock: quick add when the buy button is off screen */
  const dock = document.querySelector('[data-dock]');
  const buy = $('[data-buy]');
  if (dock && buy) {
    let frame = 0;
    const update = () => {
      frame = 0;
      const r = buy.getBoundingClientRect();
      const footer = document.querySelector('.site-footer');
      const nearFooter = footer && footer.getBoundingClientRect().top < innerHeight;
      dock.hidden = !((r.bottom < 110 || r.top > innerHeight) && !nearFooter) || document.body.classList.contains('sz-locked');
    };
    addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, { passive: true });
    addEventListener('resize', update);
    update();
    dock.querySelector('[data-dock-buy]').addEventListener('click', (e) => window.Scentzi.addItems([{ id: +idInput.value, quantity: +qtyInput.value }], e.currentTarget));
    dock.querySelector('[data-dock-change]').addEventListener('click', () => document.getElementById('abyss-kiezen').scrollIntoView({ block: 'start' }));
  }

  /* gallery thumbs; "Wat je ontvangt" shows what the chosen format contains (home + expanded pages) */
  const stage = $('.sz-gallery-stage');
  const photoStage = $('.ab-photo-stage');
  const zoomButton = photoStage && photoStage.querySelector('[data-zoom]');
  const panels = $$('[data-contents-size]');
  function showView(view) {
    const contents = view === 'contents';
    const gallery = $('.ab-gallery');
    if (gallery) gallery.dataset.galleryView = view;
    if (photoStage && panels.length) {
      photoStage.classList.toggle('ab-photo-contents', contents);
      photoStage.classList.toggle('ab-photo-product', !contents);
      if (zoomButton) zoomButton.hidden = contents;
      const size = selectedRadio() ? selectedRadio().value : panels[0].dataset.contentsSize;
      const match = panels.find((el) => el.dataset.contentsSize === size) || panels[0];
      panels.forEach((el) => { el.hidden = !contents || el !== match; });
    }
  }
  $$('[data-gallery-option]').forEach((btn) => btn.addEventListener('click', () => {
    $$('[data-gallery-option]').forEach((b) => b.setAttribute('aria-pressed', b === btn));
    if (btn.dataset.galleryOption !== 'contents' && stage) { stage.srcset = ''; stage.src = btn.dataset.src; }
    showView(btn.dataset.galleryOption);
  }));
  $$('.ab-formats input').forEach((r) => r.addEventListener('change', () => {
    if (r.dataset.image) $$('.sz-variant-thumb').forEach((img) => { img.srcset = ''; img.src = r.dataset.image; });
    const first = $('[data-gallery-option="0"]');
    if (first && r.dataset.image && $('.sz-variant-thumb')) first.dataset.src = r.dataset.image;
    const original = $('[data-gallery-option="original"]');
    if (original && r.dataset.image) original.dataset.src = r.dataset.image;
    const gallery = $('.ab-gallery');
    const styled = $('[data-gallery-option="styled"]');
    if (styled) {
      // Campaign gallery (React CampaignGallery): a new format opens on its Geurbeeld when it has one, else on the photo.
      let art = null;
      try { art = JSON.parse(styled.dataset.art || '{}')[r.value] || null; } catch (err) { art = null; }
      styled.hidden = !art;
      if (art) { styled.dataset.src = art; const t = styled.querySelector('.sz-art-thumb'); if (t) { t.srcset = ''; t.src = art; } }
      const pick = art ? styled : original;
      $$('[data-gallery-option]').forEach((b) => b.setAttribute('aria-pressed', b === pick));
      if (stage && pick && pick.dataset.src) { stage.srcset = ''; stage.src = pick.dataset.src; }
      showView(art ? 'styled' : 'original');
      return;
    }
    if (gallery) showView(gallery.dataset.galleryView || '0');
  }));

  /* zoom: the current photo full screen */
  root.addEventListener('click', (e) => {
    const z = e.target.closest('[data-zoom]');
    if (!z) return;
    const img = z.querySelector('img');
    if (!img) return;
    const layer = document.createElement('div');
    layer.className = 'sz-zoom';
    layer.setAttribute('role', 'dialog'); layer.setAttribute('aria-modal', 'true'); layer.setAttribute('aria-label', 'Productfoto');
    layer.innerHTML = `<button type="button" class="icon-button" aria-label="Sluiten">×</button><img src="${img.currentSrc || img.src}" alt="${img.alt}">`;
    const close = () => { layer.remove(); document.removeEventListener('keydown', onKey); z.focus(); };
    const onKey = (ev) => { if (ev.key === 'Escape') close(); };
    layer.addEventListener('click', close);
    document.addEventListener('keydown', onKey);
    document.body.appendChild(layer);
    layer.querySelector('button').focus();
  });

  syncTotals();
  const initial = new URL(location.href).searchParams.get('variant');
  if (initial) { const r = $(`.ab-formats input[data-variant="${initial}"]`); if (r && !r.checked) select(r); }
})();
